export default __webpack_public_path__ + "03549b0a79ec011a26da265c35c62145.png";